<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii">
<div class="img_containertitle">
<img alt="image" src="images/title_img.jpg"/>
</div>
<p class="half_t"><em class="italic">Napoleon</em> <span class="half3">in</span> <span class="half1">100</span> <span class="half2">OBJECTS</span></p>
<p class="half_tbn">Gareth Glover</p>
</a><div class="img_containerc"><a id="page_ii">
<img alt="image" src="images/logo_80.jpg"/>
<p class="captitle">FRONTLINE</p>
<p class="captitle">BOOKS</p>
</a><a id="page_iii">
</a></div><a id="page_iii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?26b246d1